import { useEffect } from "react";

export interface UseKeyboardShortcutsProps {
  handleCopy: () => void;
  handlePaste: () => void;
  undo: () => void;
  redo: () => void;
  handleDelete: () => void;
  connectionMode: { sourceStepId: string; handleIndex: number } | null;
  cancelConnectionMode: () => void;
}

export function useKeyboardShortcuts({
  handleCopy,
  handlePaste,
  undo,
  redo,
  handleDelete,
  connectionMode,
  cancelConnectionMode,
}: UseKeyboardShortcutsProps): void {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement
      ) {
        return;
      }

      if (event.key === "Escape" && connectionMode) {
        event.preventDefault();
        cancelConnectionMode();
        return;
      }

      const isMac = navigator.platform.toLowerCase().includes("mac");
      const isModifierPressed = isMac ? event.metaKey : event.ctrlKey;

      if (isModifierPressed && event.key === "c") {
        event.preventDefault();
        handleCopy();
      } else if (isModifierPressed && event.key === "v") {
        event.preventDefault();
        handlePaste();
      } else if (isModifierPressed && event.shiftKey && event.key === "z") {
        event.preventDefault();
        redo();
      } else if (isModifierPressed && event.key === "z") {
        event.preventDefault();
        undo();
      } else if (event.key === "Delete" || event.key === "Backspace") {
        event.preventDefault();
        handleDelete();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    handleCopy,
    handlePaste,
    undo,
    redo,
    handleDelete,
    connectionMode,
    cancelConnectionMode,
  ]);
}
